var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7532 0.666016H14.2465C21.1979 0.666016 26.8332 6.30126 26.8332 13.2527V14.746C26.8332 21.6974 21.1979 27.3327 14.2465 27.3327H12.7532C5.80175 27.3327 0.166504 21.6974 0.166504 14.746V13.2527C0.166504 6.30126 5.80175 0.666016 12.7532 0.666016ZM8.1665 14.9993H18.8332C19.3855 14.9993 19.8332 14.5516 19.8332 13.9993C19.8332 13.4471 19.3855 12.9993 18.8332 12.9993H8.1665C7.61422 12.9993 7.1665 13.4471 7.1665 13.9993C7.1665 14.5516 7.61422 14.9993 8.1665 14.9993Z",
    fill: "#4E545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircle);
export default __webpack_public_path__ + "static/media/removeCircle.ffa7d29cd161d76fd23d5ef262246f19.svg";
export { ForwardRef as ReactComponent };